import {ACTION_TYPES} from "../consts";
import {AnalyticsService} from "../../third-party-services/analytics/analytics-service";
import {TabClickEvent} from "../models/events/tab.click-event";
import {AnalyticsEventHandler} from "../../infrastructure/handlers/analytics-event-handler";
import {Type} from "../../infrastructure/type";

export class TabClickEventHandler extends AnalyticsEventHandler {
  type: string = ACTION_TYPES.tabChange;
  eventType: Type = TabClickEvent;

  static injectables = [AnalyticsService];
}
